import { render, staticRenderFns } from "./districtForm.vue?vue&type=template&id=17bc6060&scoped=true&"
import script from "./districtForm.vue?vue&type=script&lang=js&"
export * from "./districtForm.vue?vue&type=script&lang=js&"
import style0 from "./districtForm.vue?vue&type=style&index=0&id=17bc6060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc6060",
  null
  
)

export default component.exports